export class WindowEvent {
    constructor(data = {}, topic = '', origin = '') {
        this.data = data;
        this.topic = topic;
        this.origin = origin;
    }
}
//# sourceMappingURL=WindowEvent.js.map